import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../../utils/viewPDF";

const ViewBids = () => {
  const { tenderId } = useParams();
  const [bidData, setBidData] = useState();
  const [tender, setTender] = useState();
  const [loading, setLoading] = useState(true);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const getBidData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/bid/get-all-by-tender?tenderId=${tenderId}&username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if(res.data.Exception){
        setLoading(false);
      }
      setBidData(res.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  };

  const getTender = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTender(res.data);
    } catch (error) {
      console.error("Error updating tender status:", error);
    }
  };

  useEffect(() => {
    getTender();
    getBidData();
  }, []);

  return (
    <>
      <Box className="dashboard-container" p={10}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : tender && bidData && bidData.filter(Boolean).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "9px", width: "240px" }}>
                    Technical Specification
                  </th>
                  <th style={{ padding: "9px", width: "240px" }}>Doc Name</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(8)].map((_, i) => (
                  <tr key={i}>
                    <td
                      style={{
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      TS{i + 1}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                        padding: "8px",
                      }}
                    >
                      {tender[`ts${i + 1}Title`] || "Not required"}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td
                    colSpan={2}
                    style={{
                      borderTop: "1px solid #ccc",
                      padding: "8px",
                    }}
                  >
                    Current Status
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bidData && bidData?.length * 200}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {bidData?.filter(Boolean).map((bid, index) => (
                      <th
                        key={index}
                        style={{ width: "200px", padding: "9px" }}
                      >
                        {bid.vendor.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[...Array(8)].map((_, i) => (
                    <tr key={i}>
                      {bidData.filter(Boolean).map((bid, j) => {
                        const docUrl = bid && bid[`ts${i + 1}`];
                        return (
                          <td
                            key={j}
                            style={{
                              borderTop: "1px solid #ccc",
                              borderRight: "1px solid #ccc",
                              height: "40px",
                            }}
                          >
                            {docUrl ? (
                              <Button
                                sx={{textDecoration: 'underline'}}
                                onClick={() => viewPDF(docUrl, storedUser)}
                              >
                                Link
                              </Button>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                  <tr>
                    {bidData.filter(Boolean).map((bid, index) => (
                      <td
                        key={index}
                        style={{
                          borderTop: "1px solid #ccc",
                          height: "40px",
                        }}
                      >
                        {bid.bidStatus === "TECHNICALLY_QUALIFIED" ||
                        bid.bidStatus === "AWARDED" ||
                        bid.bidStatus === "SHORTLISTED"
                          ? "APPROVED"
                          : bid.bidStatus === "SUBMITTED"
                          ? "REVIEW"
                          : bid.bidStatus === "REBID"
                          ? "APPROVED"
                          : bid.bidStatus}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor bid for the tender
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Box sx={{ display: "flex", gap: 5 }}>
          <Button
            className="btn-outlined"
            onClick={() => navigate(`/dashboard`)}
          >
            Back
          </Button>
          <Button
            className="btn-contained"
            onClick={() => navigate(`/dashboard/review-bid/${tenderId}`)}
            disabled={bidData?.some(
              (bid) =>
                bid.bidStatus !== "SUBMITTED"
            )}
          >
            Go To Shortlist
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ViewBids;
